import type { Garage, Image, Service } from "@App/types";
import { ServiceShouldDisplayReviews } from "@App/utils/conditionals/services";

export const GarageIsBookable = (garage: Garage): boolean => garage?.pivot.bookable;

export const GarageHasAvailableDays = (garage: Garage): boolean =>
  (garage?.available_days?.length ?? 0) > 0;

export const GarageHasNationwideService = (garage: Garage): boolean =>
  garage?.nationwide_service ?? false;

export const GarageIsDrivinLicenseCheckpoint = (garage: Garage): boolean =>
  (garage?.drivingLicenseCheckpoint?.name.length ?? 0) > 0;

export const GarageHasPhone = (garage: Garage): boolean => (garage?.phone?.length ?? 0) > 0;

export const GarageHasLessImages = (images: Image[]): boolean => images?.length < 4;
export const GarageHasOneImage = (images: Image[]): boolean => images?.length === 1;

export const GarageHasBillingGroups = (garage: Garage): boolean =>
  (garage?.billingGroups?.length ?? 0) > 0;

/**
 * Whether a garage's rating may be shown on the map. The whitelabel flag is passed in rather than
 * read here, because a whitelabel can hide reviews wholesale even where the service allows them.
 */
export const GarageShouldDisplayMapMarkerRating = (
  garage: Garage,
  service: Service,
  organizationDisplaysReviews: boolean,
): boolean =>
  Boolean(
    garage?.rating &&
      organizationDisplaysReviews &&
      ServiceShouldDisplayReviews(service) &&
      GarageIsBookable(garage),
  );

export const GarageIsAuthorizedWorkshop = (garage: Garage): boolean => {
  const garageTypeId = garage?.garageType?.id;

  if (garageTypeId === null) {
    return false;
  }

  const numericId =
    typeof garageTypeId === "number" ? garageTypeId : Number.parseInt(garageTypeId, 10);
  if (Number.isNaN(numericId)) {
    return false;
  }
  return [2, 4].includes(numericId);
};
